// Mobile nav toggle
const navToggle = document.querySelector(".mobile-nav-toggle");
const navLinks = document.querySelector(".nav-links");

// Function to check if device is mobile (max-width: 50em)
const isMobile = () => window.matchMedia("(max-width: 50em)").matches;

// Wait for the DOM to be fully loaded
document.addEventListener("DOMContentLoaded", () => {
  // Initialize navigation elements and variables
  const navEl = document.querySelector(".navigation");
  let lastScrollY = window.scrollY;
  let ticking = false;
  let showingNav = true;

  // Get navigation height
  const navHeight = navEl.offsetHeight;

  if (!navEl) {
    console.error("Navigation element not found!");
    return;
  }

  // Function to update navigation visibility
  const updateNav = () => {
    // Determine scroll direction
    const scrollingDown = window.scrollY > lastScrollY;

    // Always update the last scroll position
    lastScrollY = window.scrollY;

    // Show nav at the top until we've scrolled past its height
    if (window.scrollY < navHeight) {
      if (!showingNav) {
        navEl.classList.remove("nav-hidden");
        showingNav = true;
      }
      ticking = false;
      return;
    }

    // Handle scroll direction after passing the navigation height
    if (scrollingDown) {
      // Hide the nav immediately when scrolling down
      if (showingNav) {
        navEl.classList.add("nav-hidden");
        showingNav = false;
      }
    } else {
      if (!showingNav) {
        navEl.classList.remove("nav-hidden");
        showingNav = true;
      }
    }

    ticking = false;
  };

  // Add scroll event listener with requestAnimationFrame for better performance
  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateNav();
      });
      ticking = true;
    }
  });

  // Trigger initial update
  updateNav();

  // Add smooth scrolling for navigation links
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute("href"));
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
        });
        navLinks.setAttribute("data-visible", false);
        navToggle.setAttribute("aria-expanded", false);
      }
    });
  });

  navToggle.addEventListener("click", () => {
    const visibility = navLinks.getAttribute("data-visible");

    if (visibility === "false") {
      navLinks.setAttribute("data-visible", true);
      navToggle.setAttribute("aria-expanded", true);
    } else {
      navLinks.setAttribute("data-visible", false);
      navToggle.setAttribute("aria-expanded", false);
    }
  });

  // Close menu when clicking outside
  document.addEventListener("click", (e) => {
    if (!navLinks.contains(e.target) && !navToggle.contains(e.target)) {
      navLinks.setAttribute("data-visible", false);
      navToggle.setAttribute("aria-expanded", false);
    }
  });

  // Principles hover behavior
  const principles = document.querySelectorAll(".principle");
  const firstPrinciplesList = document.querySelector(".first-principles-list");
  const inevitablesList = document.querySelector(".inevitables-list");
  const humanNatureList = document.querySelector(".human-nature-list");

  // Mobile overlay elements
  const firstPrinciplesOverlay = document.getElementById(
    "first-principles-overlay"
  );
  const inevitablesOverlay = document.getElementById("inevitables-overlay");
  const humanNatureOverlay = document.getElementById("human-nature-overlay");
  const overlayCloseButtons = document.querySelectorAll(".overlay-close");

  // Function to close all overlays
  const closeAllOverlays = () => {
    firstPrinciplesOverlay.classList.remove("active");
    inevitablesOverlay.classList.remove("active");
    humanNatureOverlay.classList.remove("active");
    document.body.classList.remove("body-overlay-active");
  };

  // Add click event listeners to close buttons
  overlayCloseButtons.forEach((button) => {
    button.addEventListener("click", closeAllOverlays);
  });

  const createDot = (principle) => {
    const dot = document.createElement("span");
    dot.className = "dot";
    principle.insertBefore(dot, principle.firstChild);
  };

  // Initially hide all lists except the default one (if any)
  if (firstPrinciplesList) firstPrinciplesList.classList.remove("hidden");
  if (inevitablesList) inevitablesList.classList.add("hidden");
  if (humanNatureList) humanNatureList.classList.add("hidden");
  if (principles && !isMobile()) {
    principles[0].querySelector("h3").classList.add("bold");
    principles[0].classList.add("active"); // Add active class to first principle

    // Create and add dot to first principle only on desktop
    createDot(principles[0]);
  }

  // Add event listeners to each principle
  principles.forEach((principle, index) => {
    const h3Element = principle.querySelector("h3");

    // Create dot element if it doesn't exist
    if (!principle.querySelector(".dot") && !isMobile()) {
      createDot(principle);
    }

    // Handle hover on desktop, click on mobile
    principle.addEventListener("pointerenter", () => {
      // Skip if mobile - we'll handle mobile with click instead
      if (isMobile()) return;

      // Remove active class from all principles
      principles.forEach((p) => p.classList.remove("active"));

      // Add active class to current principle
      principle.classList.add("active");

      // Hide all lists first
      if (firstPrinciplesList) firstPrinciplesList.classList.add("hidden");
      if (inevitablesList) inevitablesList.classList.add("hidden");
      if (humanNatureList) humanNatureList.classList.add("hidden");

      // Remove bold from all h3 elements
      principles.forEach((p) => p.querySelector("h3").classList.remove("bold"));

      // Show the appropriate list based on which principle was hovered
      if (index === 0 && firstPrinciplesList) {
        h3Element.classList.add("bold");
        firstPrinciplesList.classList.remove("hidden");
      } else if (index === 1 && inevitablesList) {
        h3Element.classList.add("bold");
        inevitablesList.classList.remove("hidden");
      } else if (index === 2 && humanNatureList) {
        h3Element.classList.add("bold");
        humanNatureList.classList.remove("hidden");
      }
    });

    // Add click event for mobile
    principle.addEventListener("click", () => {
      // Only handle overlays on mobile
      if (!isMobile()) return;

      // Close any open overlay first
      closeAllOverlays();

      // Remove bold from all h3 elements on mobile
      principles.forEach((p) => p.querySelector("h3").classList.remove("bold"));
      principles.forEach((p) => p.classList.remove("active"));

      // Add bold to clicked principle
      h3Element.classList.add("bold");

      // Show the appropriate overlay
      if (index === 0 && firstPrinciplesOverlay) {
        firstPrinciplesOverlay.classList.add("active");
        document.body.classList.add("body-overlay-active");
      } else if (index === 1 && inevitablesOverlay) {
        inevitablesOverlay.classList.add("active");
        document.body.classList.add("body-overlay-active");
      } else if (index === 2 && humanNatureOverlay) {
        humanNatureOverlay.classList.add("active");
        document.body.classList.add("body-overlay-active");
      }
    });
  });

  // Add this after the DOMContentLoaded event listener starts
  const handleMobileNav = () => {
    if (window.innerWidth < 800) {
      navLinks.setAttribute("data-visible", false);
      navToggle.setAttribute("aria-expanded", false);
    }

    // Close overlays when switching to desktop view
    if (!isMobile()) {
      closeAllOverlays();
    }
  };

  // Add resize event listener
  window.addEventListener("resize", handleMobileNav);

  // Call it once on initial load
  handleMobileNav();

  // Close overlay when clicking outside of it
  document.addEventListener("click", (e) => {
    if (
      isMobile() &&
      document.body.classList.contains("body-overlay-active") &&
      !e.target.closest(".principle") &&
      !e.target.closest(".principle-overlay")
    ) {
      closeAllOverlays();
    }
  });
});

// FORM SUBMISSION
let subscribed = false || localStorage.getItem("subscribed");
const form = document.querySelector("form");
const downloadButton = document.querySelector(".download-button");

// Function to open PDF in new tab
const openPdfInNewTab = () => {
  if (isMobile()) {
    window.location.href = "/public/thatworkstoday_prompt_pack.pdf";
  } else {
    // Use the hidden link to open PDF in new tab
    const pdfLink = document.getElementById("pdf-download-link");
    if (pdfLink) {
      pdfLink.click();
    } else {
      // Fallback if link not found
      window.open("/public/thatworkstoday_prompt_pack.pdf", "_blank");
    }
  }
};

const handleSubmission = function (event) {
  event.preventDefault();
  const formElement = event.target;
  const formData = new FormData(formElement);

  // Sending the data to netlify
  fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams(formData).toString(),
  })
    .then((response) => {
      // FIXME: reactivate before deploying
      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }
      console.log(response);

      // Clear the form
      formElement.reset();

      // Save the token to local storage
      localStorage.setItem("subscribed", true);

      // Open PDF after successful form submission
      openPdfInNewTab();
    })
    .catch((error) => {
      console.error("Submission error:", error);
      alert(`Form submission failed: please try again.`);
    });
};

// If already subscribed, show PDF immediately on button click
if (subscribed) {
  const emailInput = document.querySelector(".input-wrapper input");
  if (emailInput) {
    emailInput.placeholder = "Welcome back.";
  }

  downloadButton.addEventListener("click", (e) => {
    e.preventDefault(); // Prevent form submission
    openPdfInNewTab();
  });
}

if (!subscribed) form.addEventListener("submit", handleSubmission);
